import React, { Component } from 'react';

import { DropTarget, DragSource } from 'react-dnd'
import RemovableJumper from './removableJumper'
import EditableFunJumper from './editableFunJumper'
import AddJumpers from './addJumpers'
import CancelJump from './cancelJump'
import RenderJumperSource from './RenderJumperSource';
import { Card, CardImg, CardText, CardBody, CardTitle, CardHeader, CardFooter, Row, Col, Button, } from 'reactstrap'
import loadsStore from '../../../stores/loads-store'

const Types = {
    ITEM: 'FunJump'
};

function collect(connect, monitor) {
    return {
        connectDropTarget: connect.dropTarget(),
        //hovered: monitor.isOver(),
        //item: monitor.getItem(),
    }
}

const loadTarget = {
    // hover(props, monitor, component) {
    //     // const dragIndex = monitor.getItem().index
    //     // const hoverIndex = props.index
    // },
    drop(props, monitor, component) {
        // if (monitor.didDrop()) {
        //     // If you want, you can check whether some nested
        //     // target already handled drop
        //     return;
        // }

        const dragItem = monitor.getItem();
        const hoverItem = props;

        var targetLoad = props.loadNum;

        var jumper = dragItem.jumper;
        var jumpId = props.jumpId;
        var oldJumpId = dragItem.jumpId;

        if (jumpId == oldJumpId) {
            return;
        }

        var payload = {}
        payload.jumpId = props.jumpId;
        payload.loadNum = props.loadNum;
        payload.jumper = jumper;
        payload.oldJumpId = dragItem.jumpId;
        payload.oldLoadNum = dragItem.loadNum;
        payload.timeRemaining = dragItem.timeRemaining;
        //alert('in here')
        // dragItem.handleCreateJumper(payload);
        dragItem.handleJumperRemove(payload);
    }
}

class RenderJumperTarget extends Component {

    constructor(props) {
        super(props);
        this.state = {
            jumpers: []
        }
    }

    //loadsStore.addJumpers(this.state.loadNum, this.state.jumpId, jumpPostBody);

    // handleCreateJumper(payload) {
    //     var that = this;
    //     var jumperArray = [];
    //     jumperArray.push(payload.jumperId);
    //     var jumpPostBody = {
    //         //jumperIds: jumperArray
    //         "gearRentals": [],
    //         "jumperIds": jumperArray
    //     }

    //     var sourceLoadNum = payload.oldLoadNum;
    //     var sourceJumpId = payload.oldJumpId;
    //     var jumperId = payload.jumperId;

    //     Promise.all([loadsStore.addJumpers(payload.loadNum, payload.jumpId, jumpPostBody)])
    //         .then(function (result) {
    //             console.log(result);
    //             if (result[0] === true) {
    //                 that.handleJumperDrop(sourceLoadNum, sourceJumpId, jumperId);
    //             }
    //         })
    // }

    // handleCreateJumper(loadNum, jumpId, jumpPostBody) {
    //     var that = this;
    //     Promise.all([loadsStore.addJumpers(loadNum, jumpId, jumpPostBody)])
    //         .then(function (result) {
    //             console.log(result);
    //             if (result[0] === true) {
    //                 console.log(result[0]);
    //             }
    //         })
    // }

    // handleJumperRemove(payload) {
    //     // loadsStore.removeJumper(loadNum, jumpId, jumperId);
    //     // console.log('Test');
    //     var that = this;
    //     var jumperArray = [];
    //     jumperArray.push(payload.jumperId);
    //     var jumpPostBody = {
    //         //jumperIds: jumperArray
    //         "gearRentals": [],
    //         "jumperIds": jumperArray
    //     }

    //     var jumpId= payload.jumpId;
    //     var loadNum= payload.loadNum;

    //     var sourceLoadNum = payload.oldLoadNum;
    //     var sourceJumpId = payload.oldJumpId;
    //     var jumperId = payload.jumperId;

    //     Promise.all([loadsStore.removeJumper(sourceLoadNum, sourceJumpId, jumperId)])
    //     .then(function (result) {
    //         //console.log(result);
    //         if (result[0] === true) {
    //             // that.handleCreateJumper(payload.loadNum, payload.jumpId, jumpPostBody);
    //             that.handleCreateJumper(loadNum, jumpId, jumpPostBody);
    //             //that.handleJumperDrop(sourceLoadNum, sourceJumpId, jumperId);
    //         }
    //     })
    // }



    render() {
      console.log('rendering jumper targer');
        const { funJump, loadNum, timeRemaining, jumpId, disabled, jumperOptions, isDragging, connectDragSource, src, connectDropTarget, hovered, item, isClosed, loadsToShow , fontSize , columnsPerGroup } = this.props;
        return connectDropTarget(
            <div id={jumpId}>
                <RenderJumperSource  load={this.props.load} funJump={funJump} loadNum={loadNum} timeRemaining={timeRemaining} jumpId={jumpId} disabled={disabled}
                    isDragging={isDragging} handleCreateJumper={this.handleCreateJumper} handleJumperRemove={this.handleJumperRemove} isClosed={isClosed} loadsToShow={loadsToShow} fontSize={fontSize} columnsPerGroup={columnsPerGroup}/>
                {/* {["HopNPop", "HopNPop Student", "Solo Student", "High Pull"].indexOf(funJump.jumpType) >= 0 ? null : <AddJumpers loadNum={loadNum} jumpId={jumpId} disabled={disabled} jumperOptions={jumperOptions} />} */}
            </div>
        )
    }
}

export default DropTarget('JUMP', loadTarget, collect)(RenderJumperTarget);
//export default RenderJumperTarget;
